import { useQuery } from '@tanstack/react-query';
import { useApi } from './api';

export type Role = 'admin' | 'analyst' | 'uploader';

export interface Me {
  email: string;
  role: Role;
}

export function useMe() {
  const api = useApi();
  return useQuery({ queryKey: ['me'], queryFn: () => api.get<Me>('/api/me'), staleTime: 5 * 60_000 });
}
